module.exports = __webpack_public_path__ + "img/concept3.9a2bd1d6.png";